import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=1219cd67&scoped=true&"
import script from "./withdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalRecord.vue?vue&type=style&index=0&id=1219cd67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219cd67",
  null
  
)

export default component.exports